import React, { useState, useEffect } from 'react';
import { Tabs } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { apiGetPage } from '../../request/api';

interface ServiceItem {
  serviceName: string;
  description: string;
  fee: string;
}

interface ServiceTabsProps {
  onOpenModal?: (type: 'basic' | 'premium') => void;
  onOpenNote?: (type: 'basic' | 'premium') => void;
  id: string;
}

interface ApiServiceItem {
  serviceScope: string;
  serviceDescription: string;
  priceRemark: string | null;
  priceInfo: string;
}

const ServiceTabsInfo: React.FC<ServiceTabsProps> = ({ onOpenModal, id }) => {
  const themeColor = useSelector((state: RootState) => state.themeColor.value);
  const [hoveredService, setHoveredService] = useState<string | null>(null);
  const [groupedData, setGroupedData] = useState<Record<string, ServiceItem[]>>({});
  const [loading, setLoading] = useState(true);
  const languageCode = localStorage.getItem('siteLanguage') || 'zh';

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await apiGetPage({
          tid: '0B5BEE67FE7B419C8C33CFD33A11CA5F',
          page: 1,
          size: 100,
          languagecode: languageCode,
          search: `belongToCommodity:${id}`,
        });
        
        const rows: ApiServiceItem[] = res.data?.data?.rows || [];
        console.log('API response:', rows);
        
        // 按serviceScope分组
        const grouped = rows.reduce((acc: Record<string, ServiceItem[]>, item) => {
          const category = item.serviceScope;
          
          // 处理描述：如果priceRemark存在则添加括号
          const description = item.priceRemark ? `${item.priceRemark}` : '';
          
          const serviceItem: ServiceItem = {
            serviceName: item.serviceDescription,
            description,
            fee: item.priceInfo
          };
          
          if (!acc[category]) {
            acc[category] = [];
          }
          acc[category].push(serviceItem);
          return acc;
        }, {});
        
        setGroupedData(grouped);
      } catch (error) {
        console.error('Error fetching service data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [languageCode, id]); // 添加id作为依赖项

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '40px' }}>Loading services...</div>;
  }

  // 如果没有数据，显示提示信息
  if (Object.keys(groupedData).length === 0) {
    return <div style={{ textAlign: 'center', padding: '40px' }}>No services available</div>;
  }

  return (
    <div className="service-tabs" style={{ maxWidth: 1200, margin: '0 auto' }}>
      <Tabs
        tabPosition="top"
        tabBarStyle={{
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-start'
        }}
        items={Object.keys(groupedData).map(category => ({
          label: (
            <div className="custom-tab-label">
              <span style={{
                fontSize: '24px',
                fontWeight: 400,
                color: '#33364b',
                letterSpacing: '0.9px'
              }}>
                {category}
              </span>
            </div>
          ),
          key: category,
          children: (
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
              gap: 24,
              padding: 24
            }}>
              {groupedData[category].map(service => (
                <div
                  key={`${service.serviceName}-${Math.random()}`} // 添加随机数以确保唯一性
                  className="service-card"
                  onMouseEnter={() => setHoveredService(service.serviceName)}
                  onMouseLeave={() => setHoveredService(null)}
                >
                  <div className="card-content">
                    <h3 style={{
                      color: hoveredService === service.serviceName ? themeColor : '#33364b',
                      transition: 'color 0.3s'
                    }}>
                      {service.serviceName}
                    </h3>
                    <p className="description">{service.description}</p>
                    <div className="fee-section">
                      <span>{service.fee}</span>
                      <div
                        className="action-button"
                        style={{
                          height: '10px',
                          color: themeColor,
                          opacity: hoveredService === service.serviceName ? 1 : 0,
                          transition: 'opacity 0.3s',
                          pointerEvents: hoveredService === service.serviceName ? 'auto' : 'none'
                        }}
                        // onClick={() => onOpenModal?.('basic')}
                      >
                        {/* 我想要 */}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )
        }))}
      />
    </div>
  );
};

export default ServiceTabsInfo;